import { Injectable } from '@angular/core';
import {
  CanActivate,
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
  Router
} from '@angular/router';
import { Observable } from 'rxjs';
import { UserService } from '../services/user.service';
import { map } from 'rxjs/operators';
import { LoginService } from '@uiowa/uiowa-header';

import {ConfigService} from '..';

@Injectable({
  providedIn: 'root'
})
export class FaqGuard implements CanActivate {
  constructor(
    private router: Router,
    private readonly config: ConfigService
  ) { }

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): boolean | Observable<boolean> | Promise<boolean> {
    window.open(this.config.current.faq_url, "_blank");
    return false;
  }
}